import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditreformIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 48,
		rx: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.4802 12.7504C21.7461 12.2004 23.121 11.9469 24.4998 12.0093C25.8787 12.0717 27.225 12.4483 28.4361 13.1104L26.6673 16.8C25.9842 16.3916 25.2136 16.1518 24.4193 16.1006C23.625 16.0494 22.83 16.1882 22.1001 16.5056C21.4928 16.771 20.9436 17.1534 20.4842 17.6311C20.0248 18.1088 19.664 18.6724 19.4225 19.2896C18.9324 20.5382 18.9554 21.9299 19.4865 23.1616C19.7484 23.7703 20.1276 24.3214 20.6025 24.7835C21.0775 25.2455 21.6388 25.6095 22.2545 25.8544C22.8687 26.0987 23.5253 26.2188 24.1862 26.2078C24.847 26.1969 25.4992 26.055 26.1049 25.7904C26.8288 25.4726 27.468 24.9893 27.9711 24.3795C28.4742 23.7697 28.8272 23.0503 29.0017 22.2792L32.8993 23.5008C32.5485 24.8332 31.9009 26.0691 31.005 27.1159C30.1091 28.1627 28.988 28.9933 27.7257 29.5456C23.1129 31.5568 17.7529 29.4288 15.7521 24.7904C14.7912 22.5622 14.7495 20.0445 15.6361 17.7856C16.0732 16.6692 16.726 15.6499 17.5572 14.7858C18.3883 13.9217 19.3816 13.2298 20.4802 12.7496M16.0257 32.8536H31.8737V36H16.0257V32.8536Z",
		fill: "#019EE2"
	})]
});
export default SvgCreditreformIcon;
